import {ChangeDetectionStrategy, Component, Input, OnChanges} from "@angular/core";
import {LookupsService} from "../../../lookups";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";

/**
 * Think about moving this component to a more general place like the RISCommonModule
 */
@Component({
	selector:'cp-icon-component',
	changeDetection:ChangeDetectionStrategy.OnPush,
	styleUrls:["./icon.component.style.scss"],
	templateUrl:'./icon.component.template.html',
})
export class IconComponent implements OnChanges{

	@Input() iconClassOrKey:string|number;

	public iconClass$:Observable<string>;
	constructor(private lookupService:LookupsService) {
	}

	ngOnChanges(){
		if (typeof this.iconClassOrKey==="string"){
			this.iconClass$=Observable.create((obs) => {
				obs.next(this.iconClassOrKey);
				obs.complete();
			});
		}else {
			// create a request with no filter so we can easily change later to a cached object
			this.iconClass$ = this.lookupService.getLookup<any>(this.lookupService.createRequestGetAllRecords("ICON")).
			pipe(map(x => {
				let matchedIcon = x.lookupTable.data.filter(currRow => typeof (this.iconClassOrKey) === "number" ?
					currRow["iconKey"] === this.iconClassOrKey :
					currRow["icon"] === this.iconClassOrKey//if input as string should not come to this...
				)[0];
				return matchedIcon ? matchedIcon["icon"] : 'cp-icon-help';
			}));
		}
	}
}
